module.exports = __webpack_public_path__ + "static/GAuthCredentials-5a3942ace29b6356b35cb2b5ece8696f.png";